import React from 'react';

interface MATICIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const MATICIcon: React.FC<MATICIconProps> = ({
  width = 22,
  height = 22,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="11" cy="11" r="11" fill="#8247E5" />
      <path
        d="M14.6414 8.64659C14.3776 8.49311 14.0346 8.49311 13.7444 8.64659L11.6864 9.82333L10.2881 10.5908L8.23018 11.7675C7.96633 11.921 7.62336 11.921 7.33312 11.7675L5.69732 10.8466C5.4335 10.6931 5.24882 10.4117 5.24882 10.1047V8.28845C5.24882 7.98148 5.40711 7.70007 5.69732 7.54659L7.30674 6.65123C7.57057 6.49774 7.91357 6.49774 8.2038 6.65123L9.81319 7.54659C10.077 7.70007 10.2617 7.98148 10.2617 8.28845V9.46519L11.6601 8.67216V7.49541C11.6601 7.18845 11.5018 6.90704 11.2115 6.75356L8.23018 5.06519C7.96633 4.9117 7.62336 4.9117 7.33312 5.06519L4.29899 6.75356C4.00876 6.90704 3.85046 7.18845 3.85046 7.49541V10.8977C3.85046 11.2047 4.00876 11.4861 4.29899 11.6396L7.33312 13.328C7.59697 13.4815 7.93995 13.4815 8.23018 13.328L10.2881 12.1768L11.6864 11.3838L13.7444 10.2326C14.0082 10.0791 14.3512 10.0791 14.6414 10.2326L16.2508 11.128C16.5147 11.2815 16.6994 11.5629 16.6994 11.8699V13.6861C16.6994 13.9931 16.541 14.2745 16.2508 14.428L14.6414 15.3489C14.3776 15.5024 14.0346 15.5024 13.7444 15.3489L12.135 14.4536C11.8711 14.3001 11.6864 14.0187 11.6864 13.7117V12.535L10.2881 13.328V14.5047C10.2881 14.8117 10.4464 15.0931 10.7366 15.2466L13.7708 16.935C14.0346 17.0884 14.3776 17.0884 14.6678 16.935L17.7019 15.2466C17.9658 15.0931 18.1505 14.8117 18.1505 14.5047V11.1024C18.1505 10.7954 17.9922 10.514 17.7019 10.3605L14.6414 8.64659Z"
        fill="white"
      />
    </svg>
  );
};

export default MATICIcon;
